"use strict";

import { authConstants } from "./auth.constants";
import { profileConstants } from "./profile.constants";
import { settingConstants } from "./setting.constants";
import { fixedDepositsConstants } from "./fixedDeposits.constants";
import { generalBillPaymentsConstants } from "./generalBillPayments.constants";
import { loansConstants } from "./loans.constants";
import { favouritesConstants } from "./favourites.constants";
import { historyConstants } from "./history.constants";
import { dashboardConstants } from "./dashboard.constants";
import { creditCardPayments } from "./creditCardPayments.constants";
import { fundTransferConstants } from "./fundTransfer.constants";
import { onboardingConstants } from "./onboarding.constants";
import { accountConstants } from "./account.constants";
import { serviceRequestConstants } from "./serviceRequest.constants";
import { secureEmailConstants } from "./secureEmail.constants";
import { trafficFineConstants } from "./trafficFine.constants";
import { schedulePaymentsConstants } from "./schedulePayments.constant";

export const commonConstants = {
  AJAX_ERROR: "AJAX_ERROR",
  AJAX_SUCCESS: "AJAX_SUCCESS",
  HIDE_SUCCESS_SERVER_MESSAGE: "HIDE_SUCCESS_SERVER_MESSAGE",

  FRONTEND_MESSAGE: "FRONTEND_MESSAGE",
  SHOW_FRONTEND_MESSAGE: "SHOW_FRONTEND_MESSAGE",
  HIDE_FRONTEND_MESSAGE: "HIDE_FRONTEND_MESSAGE",

  SHOW_ERROR_SERVER_MESSAGE: "SHOW_ERROR_SERVER_MESSAGE",
  SHOW_ERROR_CONFIRM_SERVER_MESSAGE: "SHOW_ERROR_CONFIRM_SERVER_MESSAGE",
  HIDE_ERROR_SERVER_MESSAGE: "HIDE_ERROR_SERVER_MESSAGE",
  HIDE_ERROR_CONFIRM_SERVER_MESSAGE: "HIDE_ERROR_CONFIRM_SERVER_MESSAGE",
  SHOW_ERROR_CUSTOM_SERVER_MESSAGE: "SHOW_ERROR_CUSTOM_SERVER_MESSAGE",
  HIDE_ERROR_CUSTOM_SERVER_MESSAGE: "HIDE_ERROR_CUSTOM_SERVER_MESSAGE",
  ERROR_DEFAULT_MESSAGE: "Something went wrong, please try again later",
  SHOW_SUCCESS_SERVER_MESSAGE: "SHOW_SUCCESS_SERVER_MESSAGE",

  TYPE_SUCCESS_MESSAGE: "TYPE_SUCCESS_MESSAGE",
  TYPE_ERROR_MESSAGE: "TYPE_ERROR_MESSAGE",

  SUCCESS_DEFAULT_MESSAGE: "Successfully done operation",

  ADD_PENDING_ACTIONS: "ADD_PENDING_ACTIONS",
  REMOVE_PENDING_ACTIONS: "REMOVE_PENDING_ACTIONS",

  MODULE_DEFAULT_VALUE: "--",

  BANK_LIST_REQUEST: "BANK_LIST_REQUEST",
  BANK_LIST_COMPLETE: "BANK_LIST_COMPLETE",
  RESET_BANK_LIST: "RESET_BANK_LIST",

  STATUS_ERROR: "error",
  STATUS_COMPLETED: "completed",
  STATUS_SUCCESS: "success",
  STATUS_FAILURE: "failure",

  OTHER_ACCOUNT: "OTHER_ACCOUNT",
  OWN_ACCOUNT: "OWN_ACCOUNT",
  THIRD_PARTY_ACCOUNT: "THIRD_PARTY_ACCOUNT",

  SET_FIRST_TIME_LOGIN_STATE: "SET_FIRST_TIME_LOGIN_STATE",

  REQUEST_HEADER_METHOD_POST: "POST",
  REQUEST_HEADER_METHOD_GET: "GET",
  REQUEST_HEADER_METHOD_UPLOAD: "UPLOAD",

  PRINT_TYPE_FD: "PRINT_TYPE_FD",
  DEFAULT_PRINT_FILE_NAME: "Receipt.pdf",

  OTP_SEND_METHOD_TYPE_SMS: "SMS",
  OTP_SEND_METHOD_TYPE_EMAIL: "EMAIL",
  PAGE_START: 1,
  MONTH_PERIOD: "MONTHS",
  YEARS_PERIOD: "YEARS",

  LOLC_CARDS_TYPE: "ON-US",
  OTHER_CARDS_TYPE: "OFF-US",

  CLIENT_OWN_CARD: "CLIENT_OWN_CARD",
  CLIENT_OTHER_CARD: "CLIENT_OTHER_CARD",

  FORGOT_PASSWORD_TAB_LIST_SCREEN: "FORGOT_PASSWORD_TAB_LIST_SCREEN",
  FORGOT_PASSWORD_CARD_SCREEN: "FORGOT_PASSWORD_CARD_SCREEN",
  FORGOT_PASSWORD_ACCOUNT_DETAILS_SCREEN:
    "FORGOT_PASSWORD_ACCOUNT_DETAILS_SCREEN",
  FORGOT_PASSWORD_RESET_PASSWORD: "FORGOT_PASSWORD_RESET_PASSWORD",
  FORGOT_PASSWORD_RESET_PASSWORD_SUCCESS_SCREEN:
    "FORGOT_PASSWORD_RESET_PASSWORD_SUCCESS_SCREEN",

  ACCOUNT_ACTIVE_PRODUCT_STATUS: "Active",
  ACCOUNT_INACTIVE_PRODUCT_STATUS: "Inactive",
  ACCOUNT_DORMANT_PRODUCT_STATUS: "Dormant",
  ACCOUNT_UNCLAIMED_PRODUCT_STATUS: "Unclaimed",

  DOCUMENT_TYPE_NATIONAL_ID: "NATIONAL_ID",
  DOCUMENT_TYPE_PASSPORT_ID: "PASSPORT",

  BILL_PAYMENT_SELECTOR_CREDIT_CARD_TYPE: "CREDIT_CARD",
  BILL_PAYMENT_SELECTOR_PAYEE_FROM_TYPE: "PAYEE_FROM",

  VISA_TYPE_CARD: "VISA CREDIT",
  MASTER_TYPE_CARD: "MASTER CREDIT",

  PAYEE_TYPE_GROUP_CREDIT_CARD: "CREDIT_CARD",
  BANK_NAME_LOLC: "LOLC",

  RUPEES_CURRENCY_CODE: "LKR",

  NO_OPTION_TYPE: "N",
  YES_OPTION_TYPE: "Y",
  DEFAULT_SELECT_VALUE: "DEFAULT",
  NOT_AVAILABLE_TEXT: "N/A",

  BILLER_CREDIT_CARD_PAYEE: false,
  CREDIT_CARD_TYPE_MASTER: "MASTER CREDIT",
  IS_VALIDATE_API_AVAILABLE: "Y",
  IS_BILL_PRESENMENT_API_AVAILABLE: "Y",
  IS_BILLER_UPDATE_API_AVAILABLE: "Y",
  BILL_PAYEMENT_DASHBOARD_TYPE_SCREEN: "dashboard",
  BILL_PAYEMENT_BILLFORM_TYPE_SCREEN: "billform",
  BILL_PAYEMENT_CONFIRM_TYPE_SCREEN: "confirm",
  BILL_PAYEMENT_SUCCESS_TYPE_SCREEN: "success",
  BILL_PAYEMENT_PENDING_TYPE_SCREEN: "pending",
  BILL_PAYEMENT_FAILED_TYPE_SCREEN: "failed",
  BILL_PAYMENT_LPOP_WAITING_TYPE_SCREEN: "lpopwaiting",

  BILL_PAYEMENT_SUCCESS_STATUS: "SUCCESS",
  BILL_PAYEMENT_PENDING_STATUS: "PENDING",
  BILL_PAYEMENT_FAIL_STATUS: "FAILED",

  BILLER_TXN_TYPE: "TAX",

  BILL_PAYMENT_LPOP_PAYEE_GROUP: "LPOPP_V2",
  IS_REGISTERED_NO_TYPE: "N",
  IS_SCHEDULED_NO_TYPE: "N",
  BILLER_TYPE: "BILLER",
  TRANSFER_TYPE: "TRANSFER",
  MERCHANT_TXN_TYPE: "Merchant Txn",
  QR_PAYMENT_TYPE: "QR Payment",
  TRANSFER_PAYEMENT_SUCCESS_STATUS: "SUCCESS",
  TRANSFER_PAYEMENT_PENDING_STATUS: "PENDING",
  TRANSFER_PAYEMENT_FAIL_STATUS: "FAIL",
  TRANSFER_PAYEMENT_FAILED_STATUS: "FAILED",

  CREDIT_INDICATOR: "C",
  DEBIT_INDICATOR: "D",

  CREDIT_CARD_INDICATOR_NAME: "Cr",
  DEBIT_CARD_INDICATOR_NAME: "Dr",

  BIL_PAYMENTS_TYPE_ACCOUNTS: "Accounts",
  BIL_PAYMENTS_TYPE_CARDS: "Cards",
  STATUS_PENDING: "pending",

  ALL_CATEGORY_NAME_ENGLISH: "All",
  ALL_CATEGORY_NAME_SINHALA: "සියල්ල",
  ALL_CATEGORY_NAME_TAMIL: "அனைத்தும்",
  FAVOURITE_ITEM_LIST_TYPE_SCREEN: "itemlist",
  FAVOURITE_FORM_TYPE_SCREEN: "favouriteform",
  FAVOURITE_CONFIRM_TYPE_SCREEN: "confirm",
  FAVOURITE_COMPLETE_TYPE_SCREEN: "complete",
  FAVOURITE_SUCCESS_TYPE_SCREEN: "success",
  FAVOURITE_PENDING_TYPE_SCREEN: "pending",

  FAVOURITE_TYPE_BILLER: "BILLER",
  FAVOURITE_TYPE_FUND_TRANSFTER: "TRANSFER",

  TRANSFER_LIMIT_INITIAL_SCREEN: "TRANSFER_LIMIT_INITIAL_SCREEN",
  TRANSFER_LIMIT_SCREEN: "TRANSFER_LIMIT_SCREEN",
  TRANSFER_LIMIT_SUCCESS_SCREEN: "TRANSFER_LIMIT_SUCCESS_SCREEN",

  ACCOUNT_NUMBER_MAX_LENGTH: 25,
  AMOUNT_MAX_LENGTH: 11,

  BROADCAST_CHANNEL_LOLC_OB: "lolc-ob-app-channel",
  IS_MULTIPLE_TAB_OPEN: "new-tab-opened",
  IS_MULTIPLE_TAB_LOGGED_OUT: "logged-out-from-new-tab",
  LOGOUT_NEW_TAB: "logout-new-tab",

  IS_RESET_REQUEST_BY_ADMIN_YES: "Y",

  OTP_EVENT_ADD_TYPE: "ADD",
  OTP_EVENT_UPDATE_TYPE: "UPDATE",
  OTP_EVENT_DELETE_TYPE: "DELETE",

  FILTER_SUCCESS_STATUS: "SUCCESS",
  FILTER_FAILED_STATUS: "FAILED",
  FILTER_PENDING_STATUS: "PENDING",

  HISTORY_PAGE_END: 9,
  FAVOURIT_LIST_PAGE_END: 12,
  NOTIFICATION_LIST_PAGE_END: 12,

  EXP_DATE_LENGHT: 2,
  LOLC_BANK_CODE: "7861",
  FILTER_ENABLE_CHARACTER_LENGTH: 3,

  CLEAR_CUSTOM_ERRORS: "CLEAR_CUSTOM_ERRORS",
  CARD_TYPE_TAB_CREDIT: "Credit Card",
  CARD_TYPE_TAB_DEBIT: "Debit Card",

  TRANFER_SUCCESS: "success",
  TRANFER_PENDING: "pending",
  TRANFER_FAILED: "failed",
  TRANFER_DEFAULT: "default",

  TRANFER_FAILED_LABEL: "Failed",
  TRANFER_SUCCESS_LABEL: "Successful",

  DEVICE_TYPE_WEB: "Web",
  CUSTOMER_TIER_PINNACLE_TYPE: "STANDARD",
  CUSTOMER_TIER_SALARY_PLUS_TYPE: "SALARY_PLUS",
  CUSTOMER_TIER_SALARY_PARTNER_TYPE: "SALARY_PARTNER",
  CUSTOMER_TIER_PRESTIGE_TYPE: "PRESTIGE",
  CUSTOMER_TIER_PINNACLE_TYPE: "PINNACLE",

  PRODUCT_INTEREST_MATURITY: "INTEREST_MATURITY",
  PRODUCT_INTEREST_PAYABLE: "INTEREST_PAYABLE",
  MONTHLY_INTEREST: "MONTHLY",
  QUARTERLY_INTEREST: "QUARTERLY",
  BI_ANNUALLY_INTEREST: "BI_ANNUALLY",
  ANNUAL_INTEREST: "ANNUAL",
  MATURITY_INTEREST: "MATURITY",

  DO_NOT_RENEWAL: "NO",
  CAPITAL_ONLY_RENEWAL: "PAY",
  CAPITAL_PLUS_INTEREST_RENEWAL: "CAPITALISE",

  COMMON_HAS_CHANGED_FORM: "COMMON_HAS_CHANGED_FORM",

  LEASE_ACCOUNT_TYPE: "LEASE",
  PAWNING_ACCOUNT_TYPE: "PAWNING",

  COMMON_DATE_FORMAT: "DD/MM/YY",

  FORM_INPUT_DATE_FORMAT: "DD.MM.YYYY",

  COMMON_DATE_FORMAT_DD_MM_YYYY: "DD/MM/YYYY",
  COMMON_DATE_FORMAT_YYYY_MM_DD: "YYYY-MM-DD",
  COMMON_DATE_FORMAT_DD_MMM_YYYY_SLASH: "DD MMM YYYY",

  COMMON_PAGE_START: 0,
  COMMON_PAGE_END: 10,

  DISPUTE_DAYS_LIMIT: 60,

  PROFILE_PICTURE_CAMERA_LIVE_MODE: "live",
  PROFILE_PICTURE_CAMERA_PREVIEW_MODE: "preview",

  /**
   * HTMLMediaElement.readyState constants
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/readyState
   */
  MEDIA_READY_STATE_HAVE_NOTHING: 0, // No media data available
  MEDIA_READY_STATE_HAVE_METADATA: 1, // Metadata is loaded (duration, dimensions, etc.)
  MEDIA_READY_STATE_HAVE_CURRENT_DATA: 2, // Current playback position has data, but not enough for the next frame
  MEDIA_READY_STATE_HAVE_FUTURE_DATA: 3, // Data for current position and at least some future data available
  MEDIA_READY_STATE_HAVE_ENOUGH_DATA: 4, // Enough data to play through without interruption

  TRAFFIC_FINE_SUCCESS_STATUS: "SUCCESS",
  TRAFFIC_FINE_FAILURE_CUSTOMER_PAYEE_TRANSACTION_STATUS_REVERSED: "Reversed",
  TRAFFIC_FINE_FAILURE_CUSTOMER_PAYEE_TRANSACTION_STATUS_REVERSED_FAILED:
    "Reverse_Failed",

  SECUIRE_MAIL_TOAST_TITLE_CHARACTER_LENGTH: 30,
  SECUIRE_MAIL_TOAST_CHARACTER_LENGTH: 35,

  OTP_EVENT_TYPE_ADD: "ADD",
};

export const TRANSLATION_CONST = {
  ENGLISH: { lan: "en", name: "English", symbol: "A" },
  TAMIL: { lan: "ta", name: "தமிழ்", symbol: "அ" },
  SINHALA: { lan: "si", name: "සිංහල", symbol: "අ" },
};

export const loadingSelectArray = [
  authConstants.AUTH_LOGIN_REQUEST,
  authConstants.OTP_CONFIRM_REQUEST,
  authConstants.OTP_RESEND_REQUEST,
  authConstants.AUTH_LOGOUT_REQUEST,
  authConstants.IDLE_TIMEOUT_LOGOUT_REQUEST,
  // dashboardConstants.DASHBOARD_ACCOUNTS_LIST_REQUEST,
  // dashboardConstants.DASHBOARD_BANNER_LIST_REQUEST,
  // dashboardConstants.DASHBOARD_ACCOUNT_HISTORY_LIST_REQUEST,
  authConstants.FORGOT_USERNAME_VALIDATE_REQUEST,

  accountConstants.GET_ELIGIBLE_CASA_LIST_REQUEST,
  accountConstants.SAVING_ACCOUNTS_OPEN_INITIATE_REQUEST,
  accountConstants.SAVING_ACCOUNTS_OTP_CONFIRMATION_REQUEST,
  accountConstants.SAVING_ACCOUNTS_OTP_RESEND_REQUEST,
  accountConstants.SAVING_ACCOUNTS_RECEIPT_REQUEST,
  accountConstants.DOWNLOAD_ACCOUNT_STATEMENT_REQUEST,

  profileConstants.GET_PROFILE_DETAILS_REQUEST,
  profileConstants.UPDATE_DISPLAY_NAME_REQUEST,
  authConstants.FORGOT_USERNAME_OTP_CONFIRM_REQUEST,

  // creditCardPayments.MY_CREDIT_CARDS_LIST_REQUEST,

  creditCardPayments.VALIDATE_CLIENT_OTHER_CARD_REQUEST,
  creditCardPayments.CREDIT_CARD_PAY_FROM_LIST_REQUEST,
  creditCardPayments.CREDIT_CARD_VALIDATE_AMOUNT_REQUEST,
  creditCardPayments.CREDIT_CARD_PAY_BILL_REQUEST,
  creditCardPayments.CREDIT_CARD_OTP_CONFIRMATION_REQUEST,
  creditCardPayments.CREDIT_CARD_OTP_RESEND_REQUEST,
  authConstants.FORGOT_PASSWORD_VALIDATE_REQUEST,
  authConstants.FORGOT_PASSWORD_ACCOUNT_CONFIRM_REQUEST,
  generalBillPaymentsConstants.GENERAL_PAY_BILL_REQUEST,
  generalBillPaymentsConstants.PAYABLE_LIST_REQUEST,

  favouritesConstants.FAVOURITES_PAYABLE_LIST_REQUEST,
  favouritesConstants.VALIDATE_FAVOURITE_AMOUNT_REQUEST,
  favouritesConstants.FAVOURITE_PAY_BILL_REQUEST,
  favouritesConstants.FAVOURITE_OUTSTANDING_AMOUNT_REQUEST,
  favouritesConstants.UPDATE_FAVOURITE_REQUEST,
  favouritesConstants.DELETE_FAVOURITE_REQUEST,
  favouritesConstants.FAVOURITE_DETAILS_REQUEST,
  favouritesConstants.ADD_TO_FAVOURITES_REQUEST,

  generalBillPaymentsConstants.VALIDATE_BILL_AMOUNT_REQUEST,
  generalBillPaymentsConstants.OTP_CONFIRMATION_REQUEST,
  generalBillPaymentsConstants.VALIDATE_BILL_ACCOUNT_NUMBER_REQUEST,
  generalBillPaymentsConstants.FAVOURITE_OUTSTANDING_AMOUNT_REQUEST,
  // fund transfer

  fundTransferConstants.FUND_TRANSFER_PAY_FROM_LIST_REQUEST,
  fundTransferConstants.FUND_TRANSFER_PAY_TO_LIST_REQUEST,
  fundTransferConstants.FUND_TRANSFER_OWN_INITIALIZE_REQUEST,
  fundTransferConstants.FUND_TRANSFER_OTP_REQUEST,
  fundTransferConstants.FUND_TRANSFER_PROCEED_REQUEST,

  //history
  historyConstants.TRANSACTION_HISTORY_DETAIL_REQUEST,
  //onboarding
  onboardingConstants.NIC_VALIDATE_REQUEST,
  onboardingConstants.DEBIT_CARD_PRE_REGISTER_REQUEST,
  onboardingConstants.DEBIT_CARD_INIT_REGISTER_REQUEST,
  onboardingConstants.ONBOARDING_OTP_RESEND_REQUEST,
  onboardingConstants.ONBOARDING_OTP_CONFIRM_REQUEST,
  onboardingConstants.USERNAME_VALIDATE_REQUEST,
  onboardingConstants.BACKOFFICE_VALIDATION_REQUEST,
  onboardingConstants.ADD_PROFILE_INFO_REQUEST,

  //settings
  settingConstants.SETTING_CHANGE_PASSCODE_OTP_RESEND_REQUEST,
  settingConstants.SETTING_CHANGE_PASSCODE_OTP_CONFIRM_REQUEST,
  settingConstants.SETTING_OTP_PREF_GET_TWOFA_RESEND_OTP_REQUEST,
  settingConstants.SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_REQUEST,

  settingConstants.SET_ACCOUNT_NICKNAME_REQUEST,
  settingConstants.UPDATE_DEFAULT_ACCOUNT_REQUEST,

  fixedDepositsConstants.FIXED_DEPOSITS_RATE_LIST_REQUEST,
  fixedDepositsConstants.FIXED_DEPOSITS_ELIGIBLE_CASA_LIST_REQUEST,
  fixedDepositsConstants.FIXED_DEPOSITS_PRODUCT_DETAILS_REQUEST,
  fixedDepositsConstants.FIXED_DEPOSITS_OPEN_INITIATE_REQUEST,
  fixedDepositsConstants.FIXED_DEPOSITS_OTP_CONFIRMATION_REQUEST,
  fixedDepositsConstants.FIXED_DEPOSITS_OTP_RESEND_REQUEST,
  fixedDepositsConstants.FIXED_DEPOSITS_RECEIPT_REQUEST,

  // service request
  serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_CATEGORIES_LIST_REQUEST,
  serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_LIST_REQUEST,
  serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_FIELDS_REQUEST,
  serviceRequestConstants.SERVICE_REQUEST_ASSETS_OPTIONS_REQUEST,
  serviceRequestConstants.SERVICE_REQUEST_VALIDATE_REQUEST,
  serviceRequestConstants.SERVICE_REQUEST_INITIATE_REQUEST,
  serviceRequestConstants.SERVICE_REQUEST_OTP_REQUEST,
  serviceRequestConstants.SERVICE_REQUEST_RESEND_OTP_REQUEST,
  serviceRequestConstants.SERVICE_REQUEST_DETAILS_REQUEST,
  serviceRequestConstants.SERVICE_REQUEST_CANCEL_REQUEST,

  secureEmailConstants.SECURE_EMAIL_SEND_INITIATE_REQUEST,
  secureEmailConstants.SECURE_EMAIL_SEND_REQUEST,
  secureEmailConstants.SECURE_MAIL_MESSAGE_LIST_REQUEST,
  secureEmailConstants.SECURE_MAIL_DELETE_REQUEST,
  secureEmailConstants.SECURE_MAIL_RESEND_OTP_REQUEST,
  secureEmailConstants.SECURE_MAIL_FILE_DELETE_REQUEST,
  secureEmailConstants.SECURE_MAIL_MESSAGE_CLOSED_REQUEST,

  trafficFineConstants.FINES_LIST_REQUEST,
  trafficFineConstants.TRAFFIC_FINE_PAYABLE_LIST_REQUEST,
  trafficFineConstants.TRAFFIC_FINE_VALIDATE_AMOUNT_REQUEST,
  trafficFineConstants.TRAFFIC_FINE_PAYBILL_REQUEST,
  trafficFineConstants.TRAFFIC_FINE_OTP_CONFIRM_REQUEST,
  trafficFineConstants.TRAFFIC_FINE_OTP_RESEND_REQUEST,

  // schedule payments
  schedulePaymentsConstants.STOP_SCHEDULE_PAYMENT_REQUEST,
  schedulePaymentsConstants.CHANGE_ITERATION_STATUS_REQUEST,
];

export const successMessagesList = [
  settingConstants.SETTING_REMOVE_CREDIT_CARD_COMPLETE,
];

export const errorResponseCodes = {
  504: "Couldn't connect to server, Please try again.",
};

export const responseCodes = {
  AUTH_ERROR_FORBIDDEN: "403",
  SUCCESS_CODE: "00",
  SERVICE_ERROR_CODE: "01",
  REQUEST_TIMEOUT: "408",
  BAD_GATEWAY: "502",
  GATEWAY_TIMEOUT: "504",
  AUTH_ERROR_USERNAME_PASSWORD_INCORRECT: "6137",
  AUTH_ERROR_ALREADY_ONLY_MOBILE_BANKING_USER: "6266",
  AUTH_ERROR_IB_CUSTOMER_INACTIVE: "6262",
  AUTH_ERROR_SESSION_TIME_OUT: "401",
  AUTH_ERROR_PASSWORD_INCORRECT: "6283",
  AUTH_ERROR_PASSCODE_INCORRECT: "6263",
  AUTH_ERROR_ACCOUNT_BLOCK: "6285",
  AUTH_ERROR_IB_ACCOUNT_BLOCK_ADMIN: "5227",
  AUTH_ERROR_DL_ACCOUNT_BLOCK: "6106",
  AUTH_ERROR_ACCOUNT_BLOCK_OTP: "9706",
  AUTH_ERROR_OTP_CONFIRM: "9711",
  AUTH_ERROR_OTP_CONFIRM_INCORRECT: "9712",
  AUTH_ERROR_OTP_SESSION_TIMEOUT: "10002",
  AUTH_ERROR_SERVICE_SESSION_TIME_OUT: "10002",
  AUTH_ERROR_SERVICE_SESSION_INVALID: "10001",
  AUTH_ERROR_FORGOT_PASSWORD_OTP_CONFIRM_INCORRECT: "6207",
  AUTH_ERROR_FORGOT_PASSWORD_OTP_CONFIRM_INCORRECT_ACCOUNT_BLOCK: "6208",
  AUTH_ERROR_FORGOT_PASSWORD_DEBIT_CARD_PIN_INCORRECT: "6213",
  AUTH_ERROR_FORGOT_PASSWORD_ADMIN_TEMP_BLOCK: "6157",
  AUTH_ERROR_FORGOT_PASSWORD_ADMIN_BLOCK: "6856",
  AUTH_ERROR_FORGOT_PASSWORD_OTP_CONFIRM_ADMIN_BLOCK: "6206",
  AUTH_ERROR_FORGOT_PASSWORD_BLOCK: "6221",
  AUTH_ERROR_FORGOT_PASSWORD_DO_NOT_HAVE_CARD: "6212",
  AUTH_ERROR_PASSWORD_EXPIRED: "6225",
  AUTH_ERROR_PASSWORD_EXPIRED_SET_PASSWORD_ERROR: "6120",
  AUTH_ERROR_INTERNET_BANKING_BLOCKED: "6164",
  AUTH_ERROR_MOBILE_BANKING_BLOCKED: "6286",
  AUTH_ERROR_ONLINE_BANKING_BLOCKED: "6281",
  AUTH_ERROR_CUSTOMER_TEMPORARILY_BLOCKED_BY_WRONG_OTP: "6104",
  AUTH_PASSWORD_RESET: "13311",
  ADMIN_PASSWORD_RESET: "13711",

  AUTH_PASSCODE_RESET_TEMP_PASSCODE_REQUEST_SEND_ADMIN: "13314",
  AUTH_TEM_PASSWORD_INACTIVE: "13308",
  AUTH_TEM_PASSWORD_EXPIRE: "13306",

  OTP_INCORRECT: "9712",
  CARD_ALREADY_EXISTS: "11805",
  CARD_INACTIVE: "11804",
  NOT_MATCHING_CARD: "11803",
  INVALIDE_ACCOUNT_NUMBER: "9505",
  SYSTEM_ERROR: "502",
  AUTH_ERROR_ACCOUNT_NOT_ACTIVE: "5218",
  TRANSFER_LIMIT_VIOLATION: "10908",
  TRANSFER_MINIMUM_LIMIT_VIOLATION: "10915",
  TRANSFER_MAXIMUM_LIMIT_VIOLATION: "10916",
  TRANFER_RULE_VIOLATION: "10907",
  TRANFER_FOREIGN_CURRENY_NOT_ALLOWED: "10922",
  CEFT_DOWN_TIME: "10913",
  AUTH_ERROR_ADMIN_ACCOUNT_BLOCK: "6222",
  AUTH_ERROR_DIFFERENT_DEVICE_LOGIN: "10004",
  BILLER_OTP_INCORRECT: "9712",
  PAYMENT_NOT_ACCEPT: "6840",
  BILL_PAYMENT_MAX_AMNT_ERROR: "6835",
  BILL_PAYMENT_MIN_AMNT_ERROR: "6855",
  BILL_PAYMENT_FAILED: "400",
  MOBILE_NO_VALIDATION_FAILED: "12602",
  PAYONID_REGISTERED_NO_VALIDATION_FAIL: "12601",
  PAYONID_AMOUNT_MULTIPLES_VALIDATION: "12604",
  PAYONID_ACCOUNT_BALANCE_INSUFFICIENT: "10902",
  PAYONID_LIMIT_VIOLATION: "12603",
  SETTING_CHANGE_PASSCODE_IDENTICAL_PASSCODE: "6117",

  SETTING_TRANSFER_LIMIT_CUS_LIMT_EXCEED_PER_TRNX_LIMT: "9804",
  SETTING_TRANSFER_LIMIT_CUS_LIMT_LESS_THAN_PER_TRNX_LIMT: "9805",
  SETTING_TRANSFER_LIMIT_CUS_LIMT_EXCEED_PER_TRNX_DAILY_LIMT: "9806",
  SETTING_TRANSFER_LIMIT_CUS_LIMT_LESS_THAN_PER_TRNX_DAILY_LIMT: "9807",
  SETTING_TRANSFER_LIMIT_2FA_LIMIT_EXCEED: "9808",
  SETTING_TRANSFER_LIMIT_DAILY_TRNX_LIMT_EXCEED_PER_TRNX_LIMT: "9809",
  SETTING_AUTH_ERROR_PASSWORD_INCORRECT: "6131",

  EXISTING_USER_ON_BOARDING_INPROGRESS: "6170",
  ACCOUNT_NO_CAN_NOT_BE_USED_FOR_REGISTERING: "6175",
  AUTH_ERROR_KEY_PAIRE_EXPIRED: "1003",

  SAVING_ACCOUNT_OPENING_NOT_ELIGIBLE_ERROR_CODE: "16101",
  SAVING_ACCOUNT_OPEN_TRANSFER_FAIL_CODE: "16106",
  SAVING_ACCOUNT_OPENING_API_TIME_OUT_ERROR_CODE: "16106",
  SAVING_ACCOUNT_OPENING_FUND_TRANSFER_TIME_OUT_STATUS_CODE: "16108",
  SAVING_ACCOUNT_OPENING_REQUEST_STATUS_TIME_OUT_ERROR_CODE: "16107",
  SAVING_ACCOUNT_OPENING_REQUEST_STATUS_ACCOUNT_CREATE_ERROR_CODE: "16105",
  SAVING_ACCOUNT_OPENING_INSUFFICIENT_BALANCE: "16102",

  SAVING_ACCOUNT_OPENING_FAILED: "15905",
  SAVING_ACCOUNT_OPENING_FUNDS_NOT_INITIATED: "15906",
  SAVING_ACCOUNT_OPENING_TRANSFER_TIMEOUT: "15907",
  SAVING_ACCOUNT_OPENING_NOT_ELIGIBLE_CASA_ACCOUNT: "15901",

  FIXED_DEPOSIT_OPENING_FAILED: "FIXED_DEPOSIT_OPENING_FAILED",
  FIXED_DEPOSIT_OPENING_FUNDS_NOT_INITIATED: "15706",
  FIXED_DEPOSIT_OPENING_TRANSFER_TIMEOUT: "15707",

  IDLE_TIMEOUT_LOGOUT_CODE: "10006",
  INSUFFIENT_BALANCE_STATUS_CODE: "13014",
  ACTIVE_STATUS: "ACTIVE",
  CREDIT_CARD_OTP_INCORRECT: "12309",
  CANNOT_VALIDATE_BILLER_TYPE_CODE: "11508",
  MINIMUM_AMOUNT_ERROR_CODE: "6855",
  MAXIMUM_AMOUNT_ERROR_CODE: "6835",

  BILLER_INACTIVE_CODE: "11502",

  OB_PROFILE_NOT_FOUND: "6299",
  OB_ACCOUNT_LOCKED: "6390",
  OB_ACCOUNT_BLOCKED: "5211",
  OTP_FAILED: "12309",
  ONBOARDING_OTP_FAILED: "6101",
  OTP_BLOCKED: "6391",
  OTP_EXPIRED: "12306",
  OTP_REQUEST_LIMIT_REACHED: "12302",

  APPLICATION_SETTING_PW_CHANGE_INCORRECT_PW_ATTEMPT: "6284",
  APPLICATION_SETTING_PW_CHANGE_TEMP_ACC_LOCKED: "6392",

  FORGOT_USERNAME_NIC_PASSPORT_ERR0R_CODE: "9501",
  INVALID_CREDIT_CARD_NUMBER: "14205",
  INVALID_DATE_OF_BIRTH: "16110",
  INVALID_ACCOUNT: "9802",
  INVALID_ACCOUNT_TYPE_SELECTION: "6176",

  ADMIN_BLOCKED_ACCOUNT_CODE: "12312",
  OB_BLOCKED_ACCOUNT_CODE: "6261",
  ADMIN_PASSWORD_RESET_CODE: "13717",

  INVALID_FUND_TRANSFER_ACCOUNT_NUMBER: "13123",
  FUND_TRANSFER_OWN_ACCOUNT_ERROR_CODE: "13127",
  CBS_DOWN_ERROR_CODE: "12800",
  ADMIN_PASSWORD_EXPIRED_CODE: "13706",

  NO_PERSONAL_ID_FOR_ONBOARD: "6165",
  ONBOARDING_DEBIT_CARD_PIN_INVALID: "5000",
  ONBOARDING_DEBIT_CARD_NUMBER_INVALID: "16203",

  USERNAME_ALREADY_EXISTS: "6158",
  FD_OPENING_CUSTOMER_NOT_ELIGIBLE_CASA_ACCOUNT: "15701",
  NOT_ELIGIBLE_FOR_ONBOARDING: "6302",
  NO_CONTACT_INFORMATION_ONBOARDING: "9502",
  INVALID_CREDIT_CARD_DETAILS: "14203",

  CUSTOMER_ALREADY_REGISTERED_OB: "6177",

  CUSTOMER_ONBOARDING_NOT_ELIGIBLE: "14204",

  CUSTOMER_ONBOARDING_EMAIL_PHONE_ALREADY_EXISTS: "6154",

  FORGOT_PASSPORT_ERR0R_CODE: "9503",

  FUND_TRANFER_INSUFFICIENT_FUNDS_ERROR_CODE: "13005",
  ONBOARDING_ACCOUNT_BLOCKED: "6106",

  SESSION_TIME_OUT_SERVICE_ERROR_CODE: "10010",

  NOTIFICATION_NOT_AVAILABLE: "12413",

  LPOP_BILL_PAYMENT_FAILED: "11540",

  TRAFFIC_FINE_PAYMENT_FAILURE: "6827",

  FORGOT_PASSWORD_NIC_ERROR_CODE: "6169",

  STATEMENT_DOWNLOAD_EMPTY_RECORDS: "9405",
  CANNOT_DELETE_BENEFICIARY: "11543",
};

export const debitCardTypes = {
  CARD_TYPE_VISA: "Visa",
  CARD_TYPE_MASTERCARD: "Mastercard",
  CARD_TYPE_AMEX: "AMEX",
  CARD_TYPE_DISCOVER: "Discover",
  CARD_TYPE_DINERS: "Diners",
  DEBIT_CARD_TYPE_VISA: "visa",
  DEBIT_CARD_TYPE_MASTERCARD: "mastercard",
  DEBIT_CARD_TYPE_AMEX: "american-express",
};

export const sorryMessageList = [
  responseCodes.TRANSFER_MINIMUM_LIMIT_VIOLATION,
  responseCodes.TRANSFER_MAXIMUM_LIMIT_VIOLATION,
  responseCodes.TRANSFER_LIMIT_VIOLATION,
  responseCodes.CEFT_DOWN_TIME,
  responseCodes.AUTH_ERROR_FORGOT_PASSWORD_ADMIN_TEMP_BLOCK,
  responseCodes.AUTH_ERROR_FORGOT_PASSWORD_ADMIN_BLOCK,
  responseCodes.AUTH_ERROR_FORGOT_PASSWORD_BLOCK,
  responseCodes.PAYMENT_NOT_ACCEPT,
  responseCodes.BILL_PAYMENT_MAX_AMNT_ERROR,
  responseCodes.BILL_PAYMENT_MIN_AMNT_ERROR,
  responseCodes.AUTH_ERROR_PASSWORD_EXPIRED_SET_PASSWORD_ERROR,
  responseCodes.AUTH_ERROR_FORGOT_PASSWORD_DO_NOT_HAVE_CARD,
  responseCodes.AUTH_ERROR_ACCOUNT_NOT_ACTIVE,
  responseCodes.PAYONID_REGISTERED_NO_VALIDATION_FAIL,
  responseCodes.PAYONID_AMOUNT_MULTIPLES_VALIDATION,
  responseCodes.PAYONID_ACCOUNT_BALANCE_INSUFFICIENT,

  responseCodes.SETTING_CHANGE_PASSCODE_IDENTICAL_PASSCODE,
  // responseCodes.CHANGE_PASSWORD_CURRENT_PASSWORD_INCORRECT,
  // responseCodes.CHECK_PASSWORD_CONTAIN_USERNAME,

  responseCodes.AUTH_ERROR_IB_CUSTOMER_INACTIVE,
  responseCodes.AUTH_PASSCODE_RESET_TEMP_PASSCODE_REQUEST_SEND_ADMIN,
  responseCodes.ACCOUNT_NO_CAN_NOT_BE_USED_FOR_REGISTERING,
  responseCodes.SAVING_ACCOUNT_OPENING_NOT_ELIGIBLE_ERROR_CODE,
  responseCodes.SAVING_ACCOUNT_OPENING_INSUFFICIENT_BALANCE,
];

export const oopsMessageList = [
  responseCodes.TRANFER_FOREIGN_CURRENY_NOT_ALLOWED,
];

export const ohSnapMessageList = [
  responseCodes.SYSTEM_ERROR,
  responseCodes.AUTH_ERROR_OTP_SESSION_TIMEOUT,
  responseCodes.TRANFER_RULE_VIOLATION,
  responseCodes.PAYONID_LIMIT_VIOLATION,
];

export const noNeedAssistanceMessageList = [
  responseCodes.TRANSFER_LIMIT_VIOLATION,
  responseCodes.TRANSFER_MINIMUM_LIMIT_VIOLATION,
  responseCodes.TRANSFER_MAXIMUM_LIMIT_VIOLATION,
  responseCodes.CEFT_DOWN_TIME,
  responseCodes.TRANFER_FOREIGN_CURRENY_NOT_ALLOWED,
  responseCodes.PAYONID_ACCOUNT_BALANCE_INSUFFICIENT,
  responseCodes.SAVING_ACCOUNT_OPENING_INSUFFICIENT_BALANCE,
];

export const accountBlockMessageList = [
  responseCodes.AUTH_ERROR_ACCOUNT_BLOCK,
  // responseCodes.AUTH_ERROR_ACCOUNT_BLOCK_OTP,
  responseCodes.AUTH_ERROR_ADMIN_ACCOUNT_BLOCK,
  responseCodes.AUTH_ERROR_FORGOT_PASSWORD_OTP_CONFIRM_ADMIN_BLOCK,
  responseCodes.AUTH_ERROR_INTERNET_BANKING_BLOCKED,
];

export const contextApiActions = {
  UI_RIGHT_SIDE_PANEL_TOGGEL: "UI_RIGHT_SIDE_PANEL_TOGGEL",
  UI_CONFIRMATION_TOGGEL: "UI_CONFIRMATION_TOGGEL",
};

export const uiConstants = {
  COPY_FEEDBACK_RESET_MS: 5000,
};

export const regexPatterns = {
  MOBILE_VALIDATE_REGEX:
    /^(?:0)?(?:(77|76|74|70|71|72|78|75)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/,
  EMAIL_VALIDATE_REGEX:
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
  NUMBER_VALIDATION_REGEX: /^[0-9\b]+$|^$/,
  ALPHANUMERIC_VALIDATION_REGEX: /^[a-z\d\-_\s]+$|^$/i,
  ANY_NUMBER: /\d/,
  ANY_CHARACTERS: /^(?! )[a-zA-Z\d\s]*$/,
  NUMBERS_LETTERS_VALIDATION_REGEX: /^(?! )[a-zA-Z\d\s]*$/,
  SPACE_AND_ENTER_VALIDATION_REGEX: /^(?![\s\n]).*(?:\n.*)*$/,
  ANY_CHARACTERS_AND_NUMBERS: /^(?! )[a-zA-Z\s]*(?!.*\d)$/,
  PASSWORD_ALLOWED_CHARACTERS_REGEX: /^[A-Za-z\d!#$%&*()@^+=]+$/,
  FUND_TRANSFER_PHONE_VALIDATION:
    /^(?:0|94|\+94|0094)?(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|91)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/,
  OLD_NIC_NUMBER_REGEX: /^[0-9]{9}[vVxX]$/,
  NEW_NIC_NUMBER_REGEX: /^[1-9][0-9]{11}$/,
};

export const serviceRequestOtpTimeoutStatusCodes = [
  responseCodes.SERVICE_ERROR_CODE,
  responseCodes.REQUEST_TIMEOUT,
  responseCodes.BAD_GATEWAY,
  responseCodes.GATEWAY_TIMEOUT,
  Number(responseCodes.REQUEST_TIMEOUT),
  Number(responseCodes.BAD_GATEWAY),
  Number(responseCodes.GATEWAY_TIMEOUT),
];
